import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faToolbox, faTimes } from '@fortawesome/free-solid-svg-icons';
import { getApiEndpoint } from '../../../config/api';

const CRADLE_TYPES = [
  'Fixed Roof-Mounted Cradle', 'Mobile Roof-Mounted Cradle', 'Ground-Based Cradle',
  'Monorail Cradle', 'Building Maintenance Unit (BMU)', 'Davits with Suspended Cradle', 'Portable/Temporary Cradle'
];

export default function CreateCradleModal({ isOpen, onClose, onSuccess, propertyId }) {
  const [formData, setFormData] = useState({
    cradle_name: '', location: '', type: 'Fixed Roof-Mounted Cradle',
    last_inspection_date: new Date().toISOString().split('T')[0],
    last_load_test_date: new Date().toISOString().split('T')[0],
    notes: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(getApiEndpoint(`/api/properties/${propertyId}/cradles`), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(formData)
      });
      if (!response.ok) throw new Error('Failed to create cradle');
      const newCradle = await response.json();
      onSuccess(newCradle);
      onClose();
      toast.success('Cradle created successfully');
    } catch (err) {
      console.error('Error creating cradle:', err);
      toast.error(err.message);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="rs-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="rs-modal" role="dialog" aria-modal="true" aria-labelledby="create-cradle-title">
        <div className="rs-modal-header">
          <h2 id="create-cradle-title">
            <FontAwesomeIcon icon={faToolbox} style={{ marginRight: 8, color: 'var(--cs-blue, #1A80E5)' }} />
            Create Cradle
          </h2>
          <button className="rs-modal-close" onClick={onClose} aria-label="Close modal"><FontAwesomeIcon icon={faTimes} /></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="rs-modal-body">
            <div className="rs-form-grid">
              <div className="rs-form-group">
                <label htmlFor="cradle-id">ID *</label>
                <input id="cradle-id" type="text" value={formData.cradle_name} onChange={e => setFormData({ ...formData, cradle_name: e.target.value })} required placeholder="Enter cradle ID" />
              </div>
              <div className="rs-form-group">
                <label htmlFor="cradle-type">Type *</label>
                <select id="cradle-type" value={formData.type} onChange={e => setFormData({ ...formData, type: e.target.value })} required>
                  {CRADLE_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
              <div className="rs-form-group rs-full-width">
                <label htmlFor="cradle-location">Location *</label>
                <input id="cradle-location" type="text" value={formData.location} onChange={e => setFormData({ ...formData, location: e.target.value })} required placeholder="e.g., Roof Zone A" />
              </div>
              <div className="rs-form-group">
                <label htmlFor="cradle-last-date">Last Inspection Date *</label>
                <input id="cradle-last-date" type="date" value={formData.last_inspection_date} onChange={e => setFormData({ ...formData, last_inspection_date: e.target.value })} required />
              </div>
              <div className="rs-form-group">
                <label htmlFor="cradle-load-date">Last Load Test Date *</label>
                <input id="cradle-load-date" type="date" value={formData.last_load_test_date} onChange={e => setFormData({ ...formData, last_load_test_date: e.target.value })} required />
              </div>
              <div className="rs-form-group rs-full-width">
                <label htmlFor="cradle-notes">Notes</label>
                <textarea id="cradle-notes" value={formData.notes} onChange={e => setFormData({ ...formData, notes: e.target.value })} rows="3" placeholder="Additional notes..." />
              </div>
            </div>
          </div>
          <div className="rs-modal-footer">
            <button type="button" className="rs-btn rs-btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="rs-btn rs-btn-primary"><FontAwesomeIcon icon={faToolbox} /> Create Cradle</button>
          </div>
        </form>
      </div>
    </div>
  );
}
